import { Store, createStore } from "vuex";
import ProspectQuestions from "./prospect/prospectQuestions";
import LanguagePicker from "@/store/common/languagePicker";
import Overlay from "@/store/common/overlay";
import Navigation from "@/store/common/navigation";
import User from "./user";
import Prospect from "./prospect";
import ErrorTooltip from "./common/errorTooltip";
import Org from "./org";
import Assessment from "./assessment";
import { IAssessmentStore } from "@/interfaces/assessments/IAssessmentDetails";
import keyBoard from "./common/keyBoard";
import SetupWizard from "./setupWizard";
import Recommend from "./recommend";
import Scanning from "./scanning";
import Vendor from "./vendor";
import { IWizardStore } from "@/interfaces/wizard";
import Sharing from "./sharing";
import Notification from "@/store/common/notification";
import { IVenderStore } from "@/interfaces/vendor";
import LoadingAreYouSureButtonModal from "@/store/common/loadingAreYouSureButtonModal";
export interface RootState {
  ProspectQuestions: any;
  LanguagePicker: any;
  Overlay: any;
  User: any;
  Org: any;
  Prospect: any;
  Navigation: any;
  ErrorTooltip: any;
  Assessment: IAssessmentStore;
  keyBoard: any;
  SetupWizard: IWizardStore;
  Recommend: any;
  Scanning: any;
  Sharing: any;
  Vendor: IVenderStore;
  Notification: any;
  LoadingAreYouSureButtonModal: any;
}

// Create a new store instance.
const store: Store<RootState> = createStore({
  modules: {
    ProspectQuestions: ProspectQuestions,
    LanguagePicker: LanguagePicker,
    Overlay: Overlay,
    User: User,
    Org: Org,
    Prospect: Prospect,
    Navigation: Navigation,
    ErrorTooltip: ErrorTooltip,
    Assessment: Assessment,
    keyBoard,
    SetupWizard,
    Recommend,
    Scanning,
    Sharing,
    Vendor,
    Notification,
    LoadingAreYouSureButtonModal,
  },
});

export default store;
